document.addEventListener("DOMContentLoaded", function () {
  console.log("Loaded on policy page");
  const container = document.getElementsByClassName("shopify-policy__container");
  if (container) {
    container[0].style.visibility = "visible";
    document.querySelectorAll('.shopify-policy__title h1').forEach(h1 => {
      h1.textContent = toTitleCase(h1.textContent.trim());
    });

    const pathname = location.pathname;
    // console.log('pathname', pathname);
    // 設定錨點跳轉預留header高度
    if (pathname === '/policies/privacy-policy') {
      const header = document.getElementById('sticky-header');
      // console.log('header',header.offsetHeight);
      const point10 = document.getElementById('point10');
      point10.style.scrollMarginTop = `${header.offsetHeight + 10}px`;

      const noticeFinancial = document.getElementById('notice-financial');
      noticeFinancial.style.scrollMarginTop = `${header.offsetHeight + 10}px`;
    }

    // 控制 Osano 開 drawer
    const btns = document.querySelectorAll(".open-osano");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        Osano.cm.showDrawer();
      });
    });
  }

  function toTitleCase(text) {
      const lowerWords = [
        'of', 'and', 'the', 'to', 'in', 'on', 'for', 'with', 'a', 'an'
      ];
      const words = text.toLowerCase().split(' ');
      return words
        .map((word, index) => {
          const isFirst = index === 0;
          const isLast = index === words.length - 1;

          if (!isFirst && !isLast && lowerWords.includes(word)) {
            return word;
          }

          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    }
});
